import type { IBadgeProps } from './types'
import { FwbBadge } from 'flowbite-vue'

const Badge = (props: IBadgeProps, context: any) => {
  const variant = props.variant || 'gray'
  const rest = { ...props } as Record<string, any>

  // remove props we handle manually to avoid passing them twice
  delete rest.variant

  const forwardedClass = rest.class
  delete rest.class
  const forwardedClassName = rest.className
  delete rest.className

  return (
    <FwbBadge
      {...rest}
      class={[
        `bg-${variant}-100 text-${variant}-500`,
        forwardedClass,
        forwardedClassName
      ]}
    >
      {context.slots.default ? context.slots.default() : ''}
    </FwbBadge>
  )
}

export default Badge
